import { useEffect, useState } from "react";
import { isTokenExpired, spotifyApi } from "../lib/spotify";

export const useSpotifyAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const token = await spotifyApi.getAccessToken();

        if (token && !isTokenExpired(token.access_token)) {
          setIsAuthenticated(true);
          const userData = await spotifyApi.currentUser.profile();
          setUser(userData);
          setError(null);
        } else {
          setIsAuthenticated(false);
          setUser(null);
        }
      } catch (err) {
        setIsAuthenticated(false);
        setUser(null);
        setError("Failed to authenticate with Spotify");
        console.error("Spotify auth error:", err);
      }
    };

    checkAuth();

    // Check auth status every 5 minutes
    const interval = setInterval(checkAuth, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const login = async () => {
    try {
      await spotifyApi.authenticate();
    } catch (err) {
      setError("Failed to log in with Spotify");
      console.error("Spotify login error:", err);
    }
  };

  const logout = () => {
    // Clear token from storage
    localStorage.removeItem("spotify-sdk:AuthorizationCodeWithPKCE:token");
    setIsAuthenticated(false);
    setUser(null);
  };

  return {
    isAuthenticated,
    user,
    error,
    login,
    logout,
  };
};
